import { Route, Redirect } from 'react-router-dom';
import React, { Suspense, lazy, Component } from 'react';
import { Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import Login from '../../Containers/Login';
import { refreshToken } from '../../reducers/StaffAuth';
import { STAFF_TOKEN_KEY, DASHBOARD_PATH, ROUTES } from '../../config/constants';
import DashliteLayout from '../DashliteLayout';

const Dashboards = lazy(() => import('../../Containers/Dashboard'));
const Assignments = lazy(() => import('../../Containers/Assignments'));
const StudyMaterial = lazy(() => import('../../Containers/StudyMaterial'));
const Streams = lazy(() => import('../../Containers/Streams'));
const Settings = lazy(() => import('../../Containers/Settings'));
const GuidesTour = lazy(() => import('../../Containers/Guides/tour'));
const GuideDetail = lazy(() => import('../../Containers/Guides'));
const RewardPortfoliosTour = lazy(() => import('../../Containers/RewardPortfolios/tour'));
const RewardPortfolioDetail = lazy(() => import('../../Containers/RewardPortfolios'));
const Feedback = lazy(() => import('../../Containers/Feedback'));
const Conferences = lazy(() => import('../../Containers/Conferences'));
const Video = lazy(() => import('../../Containers/Video'));
const quizzes = lazy(() => import('../../Containers/Quiz'));
const reports = lazy(() => import('../../Containers/Reports'));
const ReferAndEarn = lazy(() => import('../../Containers/ReferAndEarn'));
const ReferAndEarnSubmitProof = lazy(() => import('../../Containers/ReferAndEarn/SubmitProof'));
const ReferralWallet = lazy(() => import('../../Containers/Wallet'));
const Gea = lazy(() => import('../../Containers/Gea'));

const Loader = ({ size = 'lg' }) => (
  <div className="loader-container text-center py-5">
    <Spinner size={size} color="primary" />
  </div>
);

class AppMain extends Component {
  componentDidMount() {
    const token = localStorage.getItem(STAFF_TOKEN_KEY);
    if (token && !this.props.StaffAuth.loggedIn) {
      this.props.refreshToken();
    }
  }

  render() {
    if (!this.props.StaffAuth.loggedIn) {
      return <Login />;
    }

    return (
      <DashliteLayout>
        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.DASHBOARD} component={Dashboards} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.REFERRAL_REWARDS} component={ReferAndEarn} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.SUBMIT_REFERRAL_DETAILS} component={ReferAndEarnSubmitProof} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.REFERRAL_WALLET} component={ReferralWallet} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.GEA} component={Gea} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.ASSIGNMENTS} component={Assignments} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.STUDY_MATERIAL} component={StudyMaterial} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.STREAMS} component={Streams} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.QUIZ} component={quizzes} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.REPORTS} component={reports} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.SETTINGS} component={Settings} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route exact path={ROUTES.TOUR} component={GuidesTour} />
          <Route path={`${ROUTES.TOUR}/:id`} component={GuideDetail} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route exact path={ROUTES.REWARD_PORTFOLIO} component={RewardPortfoliosTour} />
          <Route path={`${ROUTES.REWARD_PORTFOLIO}/:id`} component={RewardPortfolioDetail} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.FEEDBACK} component={Feedback} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.CONFERENCES} component={Conferences} />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <Route path={ROUTES.VIDEO} component={Video} />
        </Suspense>

        <Route exact path="/" render={() => (
          <Redirect to={DASHBOARD_PATH} />
        )} />
      </DashliteLayout>
    );
  }
}

const mapStateToProp = state => ({
  StaffAuth: state.StaffAuth,
});

const mapDispatchToProps = dispatch => ({
  refreshToken: () => refreshToken(dispatch),
});

export default connect(mapStateToProp, mapDispatchToProps)(AppMain);
